<template>
  <div class="card-grid-container">
    <router-link v-for="item in items" :key="item.title" :to="item.to">
      <card
        :thumbnail="item.thumbnail"
        :title="item.title"
        :subtitle="item.subtitle"
      />
    </router-link>
  </div>
</template>

<script>
import Card from "./Card.vue";

export default {
  name: "CardGrid",
  components: {
    Card
  },
  data() {
    return {
      items: [
        {
          title: "영화제목 초성 퀴즈",
          subtitle: "영화제목 초성 퀴즈",
          thumbnail: require("../assets/pic04.jpg"),
          to: "/movie-quiz"
        },
        {
          title: "취향 심리 테스트",
          subtitle: "취향 심리 테스트",
          thumbnail: require("../assets/pic02.jpg"),
          to: "/world-cup"
        },
        {
          title: "영어단어 퀴즈",
          subtitle: "영어단어 퀴즈",
          thumbnail: require("../assets/pic05.jpg"),
          to: "/english1"
        },
        {
          title: "사칙연산 퀴즈",
          subtitle: "두뇌트레이닝 사칙연산",
          thumbnail: require("../assets/pic03.jpg"),
          to: "/maths"
        },
        {
          title: "1 to 50",
          subtitle: "1 to 50",
          thumbnail: require("../assets/pic01.jpg"),
          to: "/onetofifty"
        },
        {
          title: "다른 색깔 찾기",
          subtitle: "다른 색깔 찾기",
          thumbnail: require("../assets/pic06.jpg"),
          to: "/find-color"
        },
        {
          title: "지뢰 찾기",
          subtitle: "지뢰 찾기",
          thumbnail: require("../assets/pic07.jpg"),
          to: "/mine-sweeper"
        }
        /*
        {
          title: "전주 2초 듣기 챌린지",
          subtitle:
            "2초 전주만 듣고 어떻게 노래 제목을 맞추는걸까? <br> 여러분도 도전해보세요!",
          thumbnail: require("../assets/pic01.jpg"),
          to: "/random-music"
        }
        */
      ]
    };
  }
};
</script>

<style>
.card-grid-container {
  --grid-gap-sm: 0.3rem;
  --grid-gap-md: 0.6rem;
  --grid-gap-xl: 0.9rem;

  grid-template-columns: 1fr;
  row-gap: var(--grid-gap-sm);
  column-gap: var(--grid-gap-sm);
  padding: var(--grid-gap-sm);
  padding-top: 0;
  margin-top: 20px;
  display: grid;
  background: #f9f9f9;
}

@media screen and (min-width: 360px) {
  .card-grid-container {
    grid-template-columns: repeat(2, 1fr);
    row-gap: var(--grid-gap-md);
    column-gap: var(--grid-gap-md);
    padding: var(--grid-gap-md);
    padding-top: 0;
  }
}

@media screen and (min-width: 768px) {
  .card-grid-container {
    grid-template-columns: repeat(3, 1fr);
    row-gap: var(--grid-gap-md);
    column-gap: var(--grid-gap-md);
    padding: var(--grid-gap-md);
    padding-top: 0;
  }
}

@media screen and (min-width: 1200px) {
  .card-grid-container {
    grid-template-columns: repeat(4, 1fr);
    row-gap: var(--grid-gap-xl);
    column-gap: var(--grid-gap-xl);
    padding: var(--grid-gap-xl);
    padding-top: 0;
  }
}
</style>
